import React, { useEffect, useState } from "react";
import Dropdown from "../common/dropdown";
import TextButtonGroup from "../common/text-button-group";
import TextInput from "../common/textinput";
import ButtonGroup from "../common/button-group";
import './projectheader.scss';
import {
  calculateButtonOptions,
  createNewCaseButtonOptions,
  designTypeButtonOptions,
  duplicateCaseButtonOptions,
  viewButtonOptions,
} from "../../constants/columns/projectdetails/buttonGroup";
import { equipmentOptions } from "../../constants/columns/projectdetails/labelColumn";
import { useAppSelector } from "../../store/hooks/StoreHooks";
import useFluidFacade from "../../facade/calculation/calculation-input/fluid.Facade";
import { DropdownOptions, toLocalISOString, updateCaseName } from "../../utilities/commonUtilities";
import { RoleConstants } from "../../utilities/AppConstants";
import WidgetLoader from "../common/widgetloader";
import useProjectHeaderFacade from "../../facade/calculation/calculation-input/projectHeader.facade";
import Notification from "../common/notification";
import { useGasCalculationFacade } from "../../facade/calculation/calculation-output/gasCalculation.facade";
import {
  BezierCurve,
  ChangeLog,
  ChevronArrowDown,
  ChevronArrowUp,
  Comparison,
  Edit,
  Message,
  Remove,
  Reports,
} from "../../assets/icons";
import useComparisonFacade from "../../facade/comparison/comparison.facade";
import CaseDialog from "./CaseDialog";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import useProjectFacade from "../../facade/project.Facade";
import useTubingFacade from "../../facade/calculation/calculation-input/tubing.facade";
import useJetliftCalculationFacade from "../../facade/jetlift/jetliftCalculations.facade";
import ConfirmationDialog from "../common/confirmation-dialog";
import { caseDetailsPayload } from "../../models/Myprojects";
import Loader from "../common/loader";
import useReportFacade from "../../facade/report/report.facade";
import useCalculationFacade from "../../facade/calculation/calculation.facade";
import Tooltip from "../common/tooltip-1";
import { ProjectStatus } from "../../utilities/AppConstants";
import Success from "../../assets/icons/Success";
import SwitchButton from "../common/switch-button";
import { useDispatch } from 'react-redux';
import { setCustomerCreated } from '../../store/dashboard/AuthSlice';
import { showToast } from "../../utilities/commonUtilities";
import Drawer from "../common/Drawer";
import Chat from "../Comments";
import Changelog from "../changelog";
import useCommentsFacade from "../../facade/comments/comments.Facade";
import { LABELS } from "../../constants/labels/chatLog.labels";
import { designType } from "../../utilities/CasingConstant";
import useCreateProjectFacade from "../../facade/createProject.Facade";
import { createJetliftCase } from "../../services/jetlift/jetliftCalculations.service";

const commentState = {
  id: 0,
  caseId: "",
  comments: "",
  isDeleted: false,
  createdBy: 0,
  createdOn: "",
  modifiedBy: 0,
  modifiedOn: "",
  createdByName: "",
  modifiedByName: "",
};

type commentsState = typeof commentState;

interface IProjectHeader {
  onClickCalculate: any;
}

const ProjectHeader: React.FC<IProjectHeader> = ({ onClickCalculate }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [notifications, setNotifications] = useState<string[]>([]);
  const { projectDetails } = useAppSelector(
    (state) => state?.calculations
  );
  const { customerEnabled, user, customerCreated } = useAppSelector((state) => state?.auth);
  const { projectReadOnly } = useAppSelector((state) => state.projectHeader);
  const { tab1Input } = useAppSelector(state => state?.tubing);
  const { tab4Input } = useAppSelector(state => state?.projectTab)
  const latestComments = useAppSelector((state) => state?.comments?.comments);
  const { commentText } = useAppSelector((state) => state?.comments);
  const [activeActionItem, setaAtiveActionItem] = useState(0);
  const [showMessageDrawer, setShowMessageDrawer] = useState({
    chat: false,
    changelog: false
  });
  const [activeCase, setActiveCase] = useState<{ index: number, case: any }>({ index: 0, case: {} });
  const [comments, setComments] = useState<commentsState>(commentState);
  const [isEditing, setIsEditing] = useState(false);
  const [selectedId, setSelectedId] = useState<any>(null);
  const { projectAndAffiliations, loading, projectsCache } = useAppSelector(
    (state) => state?.projectHeader
  );
  const { sharedCases, statusLoading } = useAppSelector((state) => state?.myProjects);
  const myProjectsState = useAppSelector(
    (state) => state?.myProjects
  );

  const { ID, caseID } = useParams();
  const parentProjectID = ID?.split("projectID=")?.[1];
  const caseId = caseID === undefined ? "" : caseID?.split("caseID=")?.[1];
  const location = useLocation();
  const pathParts = location.pathname.split("/");
  const templateIdSegment = pathParts.find(p => p.startsWith("templateID="));
  const templateId = templateIdSegment?.split("=")[1] || "";
  const { tab3Input } = useAppSelector(state => state?.fluid);
  const { isReports, isProjectDetails } = useAppSelector(state => state?.reports);
  const {
    isComparison,
    compareInput1,
    compareInput2,
    compareInput3,
  } = useAppSelector(state => state?.comparison);

  const gasNotification = useAppSelector(
    (state) => state?.gasCalculations?.Notification
  );
  const { enableReport } = useAppSelector((state) => state?.surfaceEquipment);
  const { updateOperatingFrequency } = useFluidFacade();
  const { getProjectAndAffiliationsDetails, resetProjectsCacheStore, fetchBatchProjectCalculations } = useProjectHeaderFacade();
  const { updateCatalogType } = useTubingFacade();
  const { GasCalculationStart, updateGasNotification } = useGasCalculationFacade();
  const { updateIsReport, updateIsProjectDetails } = useReportFacade();
  const { updateSchematicEquipmentData, updateAIEnabled } = useCalculationFacade();
  const { aiEnabled } = useAppSelector(state => state?.calculations);
  const {
    updateComparisonData1,
    updateIsComparison,
    updateComparisonInput1,
    updateComparisonInput2,
    updateComparisonInput3,
    loadComparisonData
  } = useComparisonFacade();
  const { loadCaseComments, loadPostComments, loadDeleteComments, loadChangeLog, updateCommentText } = useCommentsFacade();
  const { updateLiftOption } = useCreateProjectFacade();
  const [isOpen, setIsOpen] = useState(false);
  const [showCaseDialog, setShowCaseDialog] = useState(false);
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
  const [caseModalMode, setCaseModalMode] = useState('create' as any);
  const [filteredAffiliations, setFilteredAffiliations] = useState<any[]>([]);
  const [projectHeader, setProjectHeader] = useState<{
    operatingFrequency: string | number;
    catalogType: number;
  }>({
    operatingFrequency: Number(projectDetails?.tab3Input?.operatngFreq) ?? "",
    catalogType: projectDetails?.tab1Input?.catalogType,
  });
  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(false);
  const filteredProjectandAffiliations = projectAndAffiliations?.filter((item: any) => item?.liftType === 1);
  const case1ProductionOptions = filteredProjectandAffiliations?.map((x: any, index: number) => ({
    id: x.projectID, name: `Case ${index + 1}: ${x.caseName}`
  }));
  const case2ProductionOptions = filteredProjectandAffiliations
    ?.filter((item: any) =>
      customerEnabled
        ? (sharedCases?.length > 0 && sharedCases[0]?.case?.includes(item.projectID)) ||
        (
          typeof item?.userRole === "string" &&
          item?.userRole?.trim().toLowerCase()?.includes("customer") &&
          typeof item.companyName === "string" &&
          typeof tab4Input?.companyName === "string" &&
          item.companyName.trim().toLowerCase() === tab4Input.companyName.trim().toLowerCase()
        )
        : true
    )
    ?.map((x: any, index: number) => ({
      id: x.projectID, name: `${x.displayCaseName}: ${x.caseName}`
    }))
    ?.filter((x: any) => x.id !== compareInput1);

  const case3ProductionOptions = filteredProjectandAffiliations
    ?.filter((item: any) =>
      customerEnabled
        ? (sharedCases?.length > 0 && sharedCases[0]?.case?.includes(item.projectID)) ||
        (
          typeof item?.userRole === "string" &&
          item?.userRole?.trim().toLowerCase()?.includes("customer") &&
          typeof item.companyName === "string" &&
          typeof tab4Input?.companyName === "string" &&
          item.companyName.trim().toLowerCase() === tab4Input.companyName.trim().toLowerCase()
        )
        : true
    )
    ?.map((x: any, index: number) => ({
      id: x.projectID, name: `${x.displayCaseName}: ${x.caseName}`
    }))
    ?.filter((x: any) => ![compareInput1, compareInput2].includes(x.id));

  useEffect(() => {
    if (projectAndAffiliations?.length > 0) {
      const filtered = projectAndAffiliations?.filter((x: any) => {
        if (customerEnabled) {
          return (
            (sharedCases?.length > 0 && sharedCases[0]?.case?.includes(x.projectID)) ||
            (
              typeof x?.userRole === "string" &&
              x?.userRole?.trim().toLowerCase()?.includes("customer") &&
              typeof x.companyName === "string" &&
              typeof tab4Input?.companyName === "string" &&
              x.companyName.trim().toLowerCase() === tab4Input.companyName.trim().toLowerCase()
            )
          );
        }
        return true;
      });
      setFilteredAffiliations(filtered);

      if (filtered?.length > 0) {
        const caseIndex = filtered?.findIndex((x: any) => x?.projectID === caseId);
        const caseName = filtered?.find((x: any) => x?.projectID === caseId);
        const projectName = filtered?.[0];
        if (caseIndex !== -1 && caseId !== "") {
          setActiveCase((prev) => ({ ...prev, index: caseIndex, case: caseName }));
        } else {
          setActiveCase((prev) => ({ ...prev, index: 0, case: projectName }));
        }
      }
    }
  }, [projectAndAffiliations, sharedCases, tab4Input?.companyName, caseId]);

  const clearCompareInputs1 = (id: string) => {
    if (id === compareInput2) updateComparisonInput2("");
    if (id === compareInput3) updateComparisonInput3("");
    updateComparisonInput1(id)
  }

  const clearCompareInputs2 = (id: string) => {
    if (id === compareInput1) updateComparisonInput1("");
    if (id === compareInput3) updateComparisonInput3("");
    updateComparisonInput2(id)
    onCompare();
  }

  const clearCompareInputs3 = (id: string) => {
    if (id === compareInput2) updateComparisonInput2("");
    if (id === compareInput1) updateComparisonInput1("");
    updateComparisonInput3(id)
    onCompare();
  }

  const {
    copyMyProjects,
    getUpdatedSelectedProject,
    removeMyProjects,
    updateCaseDetails,
    createNewCase,
    triggerUpdateProjectStatus,
  } = useProjectFacade();
  const { CopyJetliftProject } = useJetliftCalculationFacade();


  const onCompare = async () => {
    const selectedProjects = [compareInput1, compareInput2, compareInput3].filter(value => value);
    const cacheData = projectsCache ? Object.keys(projectsCache) : [];
    const newProjects = selectedProjects.filter(x => !cacheData.includes(x));
    const compareResult: any = [];
    let items = { ...(projectsCache as any) };
    if (newProjects?.length) {
      var result: any = ""; // await fetchBatchProjectCalculations(newProjects);
      if (result?.meta?.requestStatus === "fulfilled" && result.payload) {
        items = { ...(result.payload as any), ...(projectsCache as any) }
      }
    }
    selectedProjects.forEach((key: string | number) => {
      compareResult.push(items[key]);
    });
    loadComparisonData();
  }

  const [notification, setNotification] = useState({
    type: "",
    message: "",
    show: false,
  });

  useEffect(() => {
    if (projectDetails && Object.keys(projectDetails).length > 0) {
      setProjectHeader({
        operatingFrequency: Number(projectDetails?.tab3Input?.operatngFreq),
        catalogType: tab1Input?.catalogType,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectDetails]);

  useEffect(() => {
    if (isComparison) {
      const input1 = case1ProductionOptions?.filter((x: any) => x?.id === parentProjectID);
      const input2 = case2ProductionOptions?.filter((x: any) => x?.id === compareInput2);
      const input3 = case3ProductionOptions?.filter((x: any) => x?.id === compareInput3);
      updateComparisonInput1(input1?.[0]?.id);
      updateComparisonInput2(input2?.[0]?.id);
      updateComparisonInput3(input3?.[0]?.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isComparison]);

  const onConfirmationClose = async (yes: boolean) => {
    setShowConfirmationDialog(yes);
    if (yes) {
      const payload = {
        Id: projectAndAffiliations[activeActionItem]?.projectID,
      };
      const response = await removeMyProjects(payload);
      if (response) {
        if (activeActionItem === activeCase?.index) {
          setActiveCase((prev) => ({ ...prev, index: 0 }));
        }
        getProjectAndAffiliationsDetails(parentProjectID || myProjectsState?.selectedProject?.projectID || "");
        setShowConfirmationDialog(false);
        setNotification((prev) => ({
          ...prev,
          type: "success",
          message: "Project deleted successfully.",
          show: true,
        }));
        navigate(`/project-details/projectID=${parentProjectID}`);
      }
    }
  };

  const handleCaseView = (option: any, index: number) => {
    if (customerEnabled) {
      dispatch(setCustomerCreated(option?.userRole?.toLowerCase()?.includes('customer') && option?.created_By === user?.userID ? true : false));
    }

    setActiveCase((prev) => ({ ...prev, index, case: option }));
    getUpdatedSelectedProject({
      projectID: parentProjectID ?? "",
      projectName: option?.projectName,
      caseID: option?.projectID
    });
    const selectProject = projectAndAffiliations?.find((x: any) => x.projectID === option?.projectID);
    updateLiftOption({ designType: designType?.[selectProject?.liftType as keyof typeof designType] ?? "", id: selectProject?.liftType });
    if (index === 0) {
      navigate(`/project-details/projectID=${option?.projectID}`)
    } else {
      navigate(`/project-details/projectID=${parentProjectID}/caseID=${option?.projectID}`);
    }
  };

  const handleCaseDuplicate = async (option: any, index: number) => {
    if (projectAndAffiliations.every((x: any) => [ProjectStatus.needReview, ProjectStatus.reviewInProgress].includes(x.status))) {
      let duplicateExists = projectAndAffiliations?.some((item: any) =>
        projectAndAffiliations?.some((other: any) =>
          item !== other && item?.copyFrom === option?.projectID && item?.userRole?.includes("Customer")
        )
      );

      if (duplicateExists) {
        setNotification((prev: any) => ({
          ...prev,
          type: "warning",
          message: "Only one copy allowed per shared case.",
          show: true,
        }));
        return;
      }
    }

    let caseName = updateCaseName(option?.displayCaseName, true, projectAndAffiliations);

    const isJetLift = option?.liftType === 2;

    if (isJetLift) {
      const parentCase = projectAndAffiliations?.find((x: any) => x.projectID === parentProjectID);

      const copyParams = {
        ProjectID: option?.projectID,
        ProjectName: option?.projectName || parentCase?.projectName || "",
        CaseName: option?.caseName?.trim() || "",
        DisplayCaseName: caseName,
        IsCaseLevel: true,
        customerCnxId: option?.customerCnxId || parentCase?.customerCnxId || 0,
        operatorContact: option?.operatorContact || parentCase?.operatorContact || "",
        companyName: option?.companyName || parentCase?.companyName || "",
        parentId: parentProjectID || "",
        CaseProjectId: option?.projectID || "",
      };

      CopyJetliftProject(copyParams);
    } else {
      const copyPayload = {
        ProjectId: option?.projectID,
        caseName: option?.caseName?.trim(),
        IsCaseLevel: true,
        parentId: parentProjectID,
        DisplayCaseName: caseName,
      };

      const response = await copyMyProjects(copyPayload);
      if (response) {
        setNotification((prev) => ({
          ...prev,
          type: "success",
          message: "Project copied successfully.",
          show: true,
        }));
        getProjectAndAffiliationsDetails(parentProjectID || myProjectsState?.selectedProject?.projectID || '');
      }
    }
  };

  useEffect(() => {
    if (parentProjectID) {
      getProjectAndAffiliationsDetails(parentProjectID || '');
      resetProjectsCacheStore();
      updateComparisonData1([]);
    }
  }, [parentProjectID, statusLoading]);

  useEffect(() => {
    if (customerEnabled && Array.isArray(projectAndAffiliations) && projectAndAffiliations.length > 0) {
      handleClick("DETERMINE sizing project");
      if (projectAndAffiliations?.every((x: any) => x.status === ProjectStatus.needReview)) {
        markProjectStatus(ProjectStatus.reviewInProgress);
      }
    }
  }, [customerEnabled, projectAndAffiliations]);

  const markProjectStatus = async (status: number) => {
    const response = await triggerUpdateProjectStatus({
      id: caseId || parentProjectID || "",
      status,
      updateTree: true,
    });
    if (response.payload === "Success") {
      showToast("The project status is updated to request revisions");
    } else {
      showToast(
        `Error encountered while transitioning the project to ${status === ProjectStatus.customerReady
          ? "customer-ready"
          : "request revisions"
        } status.`,
        "error"
      );
    }
  };

  const { schematicLoading, setDepthLoading } = useAppSelector(
    (state) => state?.calculations
  );
  const [reportLoading, setReportLoading] = useState(false);
  const isApiLoading = !enableReport;

  useEffect(() => {
    if (isApiLoading) {
      setReportLoading(true);
      return;
    }

    if (reportLoading) {
      const timeout = setTimeout(() => setReportLoading(false), 2500);
      return () => clearTimeout(timeout);
    }
  }, [isApiLoading, reportLoading]);

  const isReportLoading = reportLoading;
  const projectHeaderButtonOptions = [
    {
      id: 1,
      icon: (
        <BezierCurve color={isProjectDetails ? "#60BFDA" : "#F7F9F9"} />
      ),
      label: "DETERMINE sizing project",
      type: "primary",
      width: "[50%]"
    },
    {
      id: 2,
      icon: <Comparison color={isComparison ? "#60BFDA" : "#F7F9F9"} />,
      label: "Comparison",
      type: "primary",
      disabled: !!templateId,
      width: "[25%]"
    },
    {
      id: 3,
      icon: (
        <Reports
          color={
            isReports && !isReportLoading ? "#60BFDA" : isReportLoading ? "#A0A4A8" : "#F7F9F9"
          }
        />
      ),
      label: isReportLoading ? "Loading..." : "Reports",
      type: "primary",
      disabled: !!templateId || isReportLoading,
      width: "[25%]"
    },
  ];

  const {
    tab2Input
  } = useAppSelector((state) => state?.wellInput);

  useEffect(() => {
    setIsEditing(false);
    updateCommentText("");
    loadCaseComments({ caseId: caseId || parentProjectID || "" });
    if (showMessageDrawer?.changelog) {
      loadChangeLog({ caseId: caseId || parentProjectID || "" });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [caseId, parentProjectID, showMessageDrawer?.chat, showMessageDrawer?.changelog]);

  const validationsOfTubing = () => {
    const validationMessages: string[] = [];
    if (!tab1Input?.casingOD) validationMessages.push("Casing OD is required.");
    if (!tab1Input?.casingWeight)
      validationMessages.push("Casing weight is required.");
    if (!tab1Input?.tubingOD) validationMessages.push("Tubing OD is required.");
    if (!tab1Input?.tubingWeight)
      validationMessages.push("Tubing weight is required.");
    if (tab1Input?.tubingTypeUpset === "")
      validationMessages.push("Tubing type is required.");
    if (!tab1Input?.tubingType) validationMessages.push("Tubing value is required.");
    return validationMessages;
  };
  const validationsOfWellTab = () => {
    const validationMessages: string[] = [];
    if (tab2Input?.inflowTypeLstVal === "0") {
      if (!tab2Input?.piVal)
        validationMessages.push("Productivity Index (PI Val) is required.");
      if (!tab2Input?.reservoirPressure)
        validationMessages.push(
          "Static Bottom Hole Pressure (PI) is required."
        );
      if (!tab2Input?.staticFluidLvl) validationMessages.push("Static Fluid Level From Surface (PI) is required.");
    } else if (tab2Input?.inflowTypeLstVal === "1") {
      if (!tab2Input?.sbhpForPressre)
        validationMessages.push("Static Bottom Hole Pressure (P) is required.");
      if (!tab2Input?.intakePressure)
        validationMessages.push("Flowing Bottom Hole Pressure is required.");
      if (!tab2Input?.flowRate)
        validationMessages.push("Test Flow Rate is required.");
    } else if (tab2Input?.inflowTypeLstVal === "2") {
      if (!tab2Input?.flowRateForHd)
        validationMessages.push("Test Flow Rate (Head) is required.");
      if (!tab2Input?.staticFluidLvlForHd)
        validationMessages.push(
          "Static Fluid Level From Surface (Head) is required."
        );
      if (!tab2Input?.prdcngFluidLvl)
        validationMessages.push(
          "Producing Fluid Level From Surface (Head) is required."
        );
    }
    if (!tab2Input?.tubingPressure)
      validationMessages.push("Tubing Pressure is required.");
    if (!tab2Input?.productionRate)
      validationMessages.push("Desired Production Rate is required.");
    if (!tab2Input?.tvd)
      validationMessages.push("Pump Setting Vertical Depth is required.");
    if (!tab2Input?.perforation)
      validationMessages.push("Reservoir Datum is required.");
    return validationMessages;
  };

  const validationOfFluidTab = () => {
    const validationMessages: string[] = [];
    if (!tab3Input?.spGrWater)
      validationMessages.push("spGrWater is required.");
    if (!tab3Input?.waterCut)
      validationMessages.push("waterCut is required.");
    if (!tab3Input?.oilAPI)
      validationMessages.push("oilAPI is required.");
    if (!tab3Input?.spGrOil)
      validationMessages.push("spGrOil is required.");
    if (!tab3Input?.fluidViscosity)
      validationMessages.push("fluidViscosity is required.");
    if (!tab3Input?.gasProduction)
      validationMessages.push("gasProduction is required.");
    if (!tab3Input?.bubblePoint)
      validationMessages.push("bubblePoint is required.");
    if (!tab3Input?.bottomHoleTemp)
      validationMessages.push("bottomHoleTemp is required.");
    if (!tab3Input?.surfaceTemperature)
      validationMessages.push("surfaceTemperature is required.");
    if (!tab3Input?.operatngFreq)
      validationMessages.push("Operating frequency is required.");
    return validationMessages;
  };

  const handleAIGasModifier = (checked: boolean) => {
    updateAIEnabled(checked)
  }

  const onClickCalculate1 = () => {
    const validationMessages = validationsOfTubing();
    const validationMessagesOfWellTab = validationsOfWellTab();
    const validationMessagesOfFluidTab = validationOfFluidTab();

    const allValidationMessages = [
      ...validationMessages,
      ...validationMessagesOfWellTab,
      ...validationMessagesOfFluidTab,
    ];
    updateSchematicEquipmentData();
    if (allValidationMessages.length > 0) {
      setNotifications((prevNotifications) => [
        ...prevNotifications,
        ...allValidationMessages,
      ]);
    } else {
      try {
        GasCalculationStart();
      } catch (err) {
        console.log(err, "calculate err");
        // validationMessages.push(err);
      }
    }
  };

  const removeNotification = (index: number) => {
    setNotifications((prevNotifications) =>
      prevNotifications.filter((_, i) => i !== index)
    );
  };

  const handleOpenDrawer = () => {
    setIsDrawerOpen(true);
  };

  const handleClick = (unit: string) => {
    updateIsReport(false);
    updateIsComparison(false);
    updateIsProjectDetails(false)
    if (unit == 'DETERMINE sizing project') {
      updateIsProjectDetails(true)
    }
    else if (unit === 'Comparison') {
      updateIsComparison(true);
      setIsOpen(false);
    }
    else if (unit === 'Reports') {
      updateIsReport(true);
      setIsOpen(false);
    }
    else {
      updateIsComparison(false);
    }
  };

  const handleCaseDialogClose = async (payload?: caseDetailsPayload) => {
    if (payload) {
      if (caseModalMode === 'update') {
        const response = await updateCaseDetails({ projectId: projectAndAffiliations[activeActionItem]?.projectID, ...payload });
        if (response) {
          setNotification((prev) => ({
            ...prev,
            type: "success",
            message: "Case updated successfully.",
            show: true,
          }));
          getProjectAndAffiliationsDetails(parentProjectID || myProjectsState?.selectedProject?.projectID || '');
        }
      } else {
        const parentCase = projectAndAffiliations?.find((x: any) => x.projectID === parentProjectID);
        if (parentCase) {
          let caseName = updateCaseName("", false, filteredAffiliations);
          const casePayload: any = {
            ...parentCase,
            projectID: '',
            parentId: parentCase?.projectID,
            ...payload,
            DisplayCaseName: caseName,
            copyFrom: null,
            liftType: payload?.liftType === 'ESP' ? 1 : 2
          };
          let response;
          if (payload?.liftType === 'Jet lift') {
            response = await createJetliftCase(casePayload);
          } else if (payload?.liftType === 'ESP') {
            response = await createNewCase({ ...parentCase, projectID: '', parentId: parentCase?.projectID, ...payload, DisplayCaseName: caseName, copyFrom: null, liftType: 1 });
          }
          if (response) {
            setNotification((prev) => ({
              ...prev,
              type: "success",
              message: "Case created successfully.",
              show: true,
            }));
            getProjectAndAffiliationsDetails(parentProjectID || myProjectsState?.selectedProject?.projectID || '');
          }
        }
      }

    }
    setShowCaseDialog(false);
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e?.target;
    const validNumberRegex = /^\d*\.?\d*$/;
    let newValue = value === "" ? "0" : value;

    if (validNumberRegex.test(newValue) && Number(newValue) <= 100) {
      setProjectHeader((prev) => ({ ...prev, operatingFrequency: newValue }));
    }
  };

  const handleBlur = (e: React.ChangeEvent<HTMLInputElement>) => {
    updateOperatingFrequency(Number(projectHeader?.operatingFrequency));
  };

  const handleSelect = (option: DropdownOptions) => {
    setProjectHeader((prev) => ({ ...prev, catalogType: Number(option?.id) }));
    updateCatalogType(Number(option?.id));
  };

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  const getProjectStatus = () => {
    if (projectAndAffiliations?.length > 0 && projectAndAffiliations?.find((item: any) => item?.status === ProjectStatus?.acknowldged)) return true;
    else if (projectAndAffiliations?.length > 0 && projectAndAffiliations?.every((item: any) => item?.status === ProjectStatus?.needReview)) return true;
    else if (projectAndAffiliations?.length > 0 && projectAndAffiliations?.every((item: any) => item?.status === ProjectStatus?.reviewInProgress)) return true;
  };

  const handlePostComment = (comment: any) => {
    const payload = {
      id: comment?.id,
      caseId: caseId || parentProjectID || "",
      comments: comment?.comments,
      isDeleted: false,
      createdBy: comment?.createdBy || user?.userID,
      CreatedOn: toLocalISOString(new Date()),
      modifiedBy: comment?.modifiedBy || user?.userID,
      ModifiedOn: toLocalISOString(new Date()),
      createdByName: user?.userFullName,
      modifiedByName: user?.userFullName,
    };
    const updatePayload = {
      payload,
      caseId: caseId || parentProjectID || "",
    }
    loadPostComments(updatePayload);
  };

  const handleEditComment = (id: string) => {
    const comment = latestComments.find((c: any) => c.id?.toString() === id);
    if (!comment) return;
    const payload = {
      id: comment?.id,
      caseId: caseId || parentProjectID || "",
      comments: commentText || comment?.comments,
      isDeleted: false,
      createdBy: comment?.createdBy,
      createdOn: new Date()?.toLocaleString(),
      modifiedBy: comment?.modifiedBy,
      modifiedOn: new Date()?.toLocaleString(),
      createdByName: comment?.createdByName,
      modifiedByName: user?.userFullName,
    };
    const editPayload = {
      payload,
      caseId: caseId || parentProjectID || "",
    }
    loadPostComments(editPayload);
  };

  const handleDeleteComment = (id: string) => {
    loadDeleteComments({ id: id, caseId: caseId || parentProjectID || "" });
  };

  return (
    <div
      className={`flex flex-col items-center justify-center w-full border-[1px] rounded-[8px] ${isComparison ? "min-h-[80px]" : "min-h-[150px]"
        } border-solid border-darkcolor-400 bg-darkcolor-700`}
    >
      {myProjectsState?.loading && (
        <Loader isLoading={myProjectsState?.loading} />
      )}
      {loading ? (
        <div className='absolute flex justify-center items-center bg-darkcolor-700 bg-opacity-30'>
          <WidgetLoader isLoading={loading} />
        </div>
      ) : (
        <>
          <div
            className={`flex flex-col w-full py-3 px-4 ${isComparison ? "border-b-[0]" : "border-b-[1px]"
              } border-darkcolor-400 ${templateId ? "items-end" : ""}`}
          >
            <div className='flex justify-between gap-[16px]'>
              {isComparison ? (
                <div className='flex items-center gap-[12px]'>
                  <Dropdown
                    options={case1ProductionOptions}
                    selected={compareInput1}
                    onSelect={(opt: any) => clearCompareInputs1(opt.id)}
                    bgColor='bg-transparent'
                    dropdownBgColor='bg-darkcolor-800'
                    disabled={true}
                  />
                  <Dropdown
                    options={case2ProductionOptions}
                    selected={compareInput2}
                    onSelect={(opt: any) => clearCompareInputs2(opt.id)}
                    bgColor='bg-transparent'
                    dropdownBgColor='bg-darkcolor-800'
                    disabled={false}
                    showSelectOption
                    showCloseIcon={true}
                    overrideEnableFlag={true}
                  />
                  <Dropdown
                    options={case3ProductionOptions}
                    selected={compareInput3}
                    onSelect={(opt: any) => clearCompareInputs3(opt.id)}
                    bgColor='bg-transparent'
                    dropdownBgColor='bg-darkcolor-800'
                    disabled={false}
                    showSelectOption
                    showCloseIcon={true}
                    overrideEnableFlag={true}
                  />
                </div>
              ) : (
                !templateId && (
                  <div className='flex gap-[12px]'>
                    <div
                      className={`relative flex flex-col gap-[6px] w-full rounded-[8px]`}
                    >
                      <div
                        className={`relative border-darkcolor-400 border-[1px] ${isOpen
                          ? "rounded-t-[8px] pb-2 bg-darkcolor-800 border-b-0 case-dropdown-active"
                          : "rounded-[8px]"
                          }`}
                      >
                        <button
                          onClick={toggleDropdown}
                          className='flex justify-between items-center gap-[8px] w-full py-2 px-4 rounded-[8px]  bg-darkcolor-800 focus:outline-none'
                        >
                          <span className='text-neutral-25 text-[18px] font-semibold'>
                            {`${activeCase?.index + 1 || 1}`}:{" "}
                            {projectAndAffiliations?.length &&
                              activeCase?.case?.caseName}
                            <span className='p-[8px] rounded-[4px] gap-[8px] border-[1px] border-primary-700 bg-primary-600 shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)] font-normal pt-[1px] pb-[1px] pl-[7px] pr-[7px] text-[12px] ml-2'>
                              {filteredAffiliations?.length}
                            </span>
                          </span>
                          {isOpen ? (
                            <ChevronArrowUp size={20} className='mt-2' />
                          ) : (
                            <ChevronArrowDown size={20} className='mb-2' />
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                )
              )}
              <div className='flex items-center justify-center gap-[20px] '>
                {!templateId && (
                  <Tooltip content={!showMessageDrawer?.chat && LABELS?.comments}>
                    <div style={{ position: "relative", display: "inline-block" }}>
                      <Message
                        size={20}
                        color="#F7F9F9"
                        onClick={() =>
                          setShowMessageDrawer({ ...showMessageDrawer, chat: !showMessageDrawer?.chat })
                        }
                        style={{ cursor: "pointer" }}
                      />
                      {Array.isArray(latestComments) && latestComments.length > 0 && (
                        <span
                          style={{
                            position: "absolute",
                            top: 0,
                            right: 0,
                            width: "10px",
                            height: "10px",
                            background: "#FF4D4F",
                            borderRadius: "50%",
                            border: "2px solid #222B36",
                          }}
                        />
                      )}
                    </div>
                  </Tooltip>)}
                {caseId !== "" && !templateId &&
                  ((sharedCases && !sharedCases[0]?.case?.includes(caseId || parentProjectID)) || !customerEnabled) &&
                  projectAndAffiliations?.find((x: any) => x?.projectID === (caseId || parentProjectID))?.copyFrom !== null &&
                  (
                    <Tooltip content={!showMessageDrawer?.changelog && LABELS?.changeLog}>
                      <ChangeLog size={20} color='#F7F9F9' onClick={() => setShowMessageDrawer({ ...showMessageDrawer, changelog: !showMessageDrawer?.changelog })} style={{ cursor: 'pointer' }} />
                    </Tooltip>
                  )}
                <TextButtonGroup
                  label=''
                  //unit={isComparison ? "Comparison" : "DETERMINE sizing project"}
                  unit={
                    isComparison
                      ? "Comparison"
                      : isProjectDetails
                        ? "DETERMINE sizing project"
                        : isReportLoading
                          ? "Loading..."
                          : "Reports"
                  }
                  handleClick={(option) => handleClick(option)}
                  width={"100%"}
                  buttonOptions={projectHeaderButtonOptions}
                />
              </div>
            </div>
            {isProjectDetails && isOpen && (
              <div className='w-full border-[1px] bg-darkcolor-800 border-darkcolor-400 rounded-b-[8px] p-4'>
                <div className='flex flex-wrap gap-8 text-neutral-25'>
                  {filteredAffiliations?.map((x: any, index: number) => {
                    return (
                      <div className={`
                            p-4 
                            rounded-[8px] 
                            bg-darkcolor-700 
                            border 
                            w-[340px] 
                            ${activeCase?.index === index
                          ? 'border-2 border-primary-600'
                          : 'border border-darkcolor-400'
                        }
                        `}>
                        <div className='flex justify-between w-full mb-0'>
                          {activeCase?.index === index && (
                            <div className='bg-primary-600 w-1 rounded-[4px] mr-2 mb-3 mt-1'></div>
                          )}
                          <div className='flex size-12 flex-1'>
                            <div className='flex flex-1 gap-[8px] text-[14px] font-normal mb-1 grow-5 size-8'>
                              {x?.displayCaseName}
                              <div>
                                <span className='border border-color-[#E8E3EF] rounded px-2 py-[2px] text-color-[#FCFCFD] text-[12px] font-semibold'>
                                  {x?.liftType === 1 ? "ESP" : "Jet lift"}
                                </span>
                              </div>
                            </div>
                            {((!customerEnabled &&
                              !projectReadOnly &&
                              x.status !== ProjectStatus.acknowldged) ||
                              (customerEnabled &&
                                x.created_By === user?.userID &&
                                projectAndAffiliations?.every((item: any) => item?.status !== ProjectStatus?.acknowldged))) && (
                                <div className='flex-2 gap-4 flex grow-5'>
                                  <a
                                    flex-1
                                    href='javascript:void(0)'
                                    onClick={() => {
                                      setShowCaseDialog(true);
                                      setCaseModalMode("update");
                                      setaAtiveActionItem(projectAndAffiliations?.findIndex((item: any) => item?.projectID === x.projectID));
                                    }}
                                  >
                                    <Edit />
                                  </a>
                                  <Tooltip
                                    content={
                                      sharedCases?.length > 0 &&
                                      sharedCases[0]?.case?.includes(
                                        x.projectID
                                      ) &&
                                      parentProjectID !== x.projectID &&
                                      "Unshare the case to delete"
                                    }
                                  >
                                    <a
                                      flex-2
                                      href='javascript:void(0)'
                                      className={
                                        parentProjectID === x.projectID ||
                                          (sharedCases?.length &&
                                            sharedCases[0]?.case?.includes(
                                              x.projectID
                                            )) || projectAndAffiliations?.find((item: any) => item?.copyFrom === x.projectID)
                                          ? "opacity-5 cursor-not-allowed pointer-events-none"
                                          : ""
                                      }
                                      onClick={() => {
                                        setShowConfirmationDialog(true);
                                        setaAtiveActionItem(projectAndAffiliations?.findIndex((item: any) => item?.projectID === x.projectID));
                                      }}
                                    >
                                      <Remove />
                                    </a>
                                  </Tooltip>
                                </div>
                              )}
                          </div>
                        </div>
                        <div className='text-[18px] font-normal mb-2 min-h-[24px] break-words'>
                          {" "}
                          {x?.caseName}
                        </div>

                        <div className=' text-[14px] font-normal mb-2 min-h-[24px] break-words'>
                          {x?.caseDescription}
                        </div>
                        <div className='flex mb-4 items-center'>
                          <div className="text-[10px] font-normal">Created by: {x?.createdByName}</div>
                          <div className="flex items-center gap-[10px] text-[10px] font-normal">
                            {(sharedCases?.length > 0 &&
                              sharedCases[0]?.case?.includes(x.projectID) &&
                              x.status !== ProjectStatus.acknowldged) ? (
                              <>
                                <div className="text-neutral-100 ml-2">|</div>
                                <span className='border border-warning-400 rounded px-1 py-0 text-warning-400'>
                                  Shared
                                </span>
                              </>
                            ) : (
                              x?.userRole?.toLowerCase()?.includes('customer') && (
                                <>
                                  <div className="text-neutral-100 ml-2">|</div>
                                  <span className='border border-warning-400 rounded px-1 py-0 text-warning-400'>
                                    Customer
                                  </span>
                                </>
                              )
                            )}

                            {x.status === ProjectStatus.acknowldged && (
                              <>
                                <div className="text-neutral-100 ml-2">|</div>
                                <span className='flex items-center border border-[#48bb78] rounded px-1 py-0 text-[#48bb78]'>
                                  <Success color='#48bb78' size={16} />
                                  &nbsp;Acknowledged
                                </span>
                              </>
                            )}
                          </div>
                        </div>
                        <div className='border-b-[1px] border-darkcolor-400 mb-4'></div>
                        <div className='flex justify-between gap-4'>
                          {
                            (!projectAndAffiliations?.find((x: any) => x.status === ProjectStatus.acknowldged) &&
                              ((!projectReadOnly && ![ProjectStatus?.acknowldged, ProjectStatus?.needReview, ProjectStatus?.reviewInProgress]?.includes(x?.status) && !customerEnabled) ||
                                (sharedCases?.length > 0 && sharedCases[0]?.case?.includes(x.projectID) && (sharedCases[0]?.email || "").trim().toLowerCase() === (user?.email || "").trim().toLowerCase()
                                )))
                            &&
                            (
                              <ButtonGroup
                                buttonOptions={duplicateCaseButtonOptions}
                                handleClick={async () =>
                                  await handleCaseDuplicate(x, index)
                                }
                                className='w-2/4'
                              />
                            )}
                          <ButtonGroup
                            buttonOptions={viewButtonOptions}
                            handleClick={() => handleCaseView(x, index)}
                            className='w-2/4'
                          />
                        </div>
                      </div>
                    );
                  })}
                  {!customerEnabled &&
                    !projectReadOnly &&
                    projectAndAffiliations?.filter(
                      (item: any) => item?.status === ProjectStatus.inProgress
                    )?.length > 0 && (
                      <div className='flex flex-col p-4 rounded-[8px] bg-darkcolor-700 border-darkcolor-400 w-[340px] items-center justify-center min-h-[244px]'>
                        <div className='flex justify-center w-full mb-4'>
                          <div className='text-[16px]  mb-1'>
                            {" "}
                            Create new case
                          </div>
                        </div>
                        <div className='text-center text-[14px] font-normal mb-4'>
                          Initiate a new sizing configuration for selected well
                        </div>
                        <div className='flex justify-between gap-4'>
                          <ButtonGroup
                            buttonOptions={createNewCaseButtonOptions}
                            handleClick={() => {
                              setShowCaseDialog(true);
                              setCaseModalMode("create");
                            }}
                          />
                        </div>
                      </div>
                    )}
                </div>
              </div>
            )}
          </div>
          {!isComparison && (
            <div className='flex justify-between items-center w-full py-3 px-4'>
              <div className='flex gap-[12px]'>
                <TextInput
                  label='Operating Frequency'
                  placeholder={"Enter Frequency"}
                  value={projectHeader?.operatingFrequency || "0"}
                  onChange={(e) => handleChange(e)}
                  onBlur={(e) => handleBlur(e)}
                  unit={
                    projectDetails?.pumpInput?.actNamePump_OperatingFrequency ||
                    "Hz"
                  }
                  required
                  disabled={false}
                />
                {(user?.userRole?.includes(RoleConstants.aiApplicationEngineer) ||
                  user?.userRole?.includes(RoleConstants.admin)) && (
                    <div className='flex gap-[12px] w-full pt-4 mt-4'>
                      <SwitchButton
                        checked={aiEnabled}
                        onChange={handleAIGasModifier}
                        label='AI Gas Modifier'
                      />
                    </div>
                  )}
                {((customerEnabled && customerCreated && projectAndAffiliations?.every((item: any) => item?.status !== ProjectStatus?.acknowldged)) ||
                  (!customerEnabled && !projectReadOnly)) && (
                    <div className='pt-9'>
                      <ButtonGroup
                        buttonOptions={calculateButtonOptions}
                        handleClick={onClickCalculate1}
                      />
                    </div>
                  )}
              </div>
              <div className='flex justify-center items-center gap-[12px]'>
                <Dropdown
                  label='Equipment offering'
                  options={equipmentOptions}
                  dropdownBgColor='bg-darkcolor-800'
                  width='300px'
                  onSelect={(option) => handleSelect(option)}
                  placeholder={"Select an option...."}
                  selected={tab1Input?.catalogType?.toString()}
                />
              </div>
            </div>
          )}
        </>
      )}
      <div className='fixed top-4 right-4 z-[1005] flex flex-col space-y-4'>
        {notifications.map((message, index) => (
          <Notification
            key={index}
            type='error'
            message={message}
            onClose={() => removeNotification(index)}
            isOpen={true}
            timeout={2000}
          />
        ))}
        {(notification?.show || gasNotification?.show) && (
          <Notification
            isOpen={notification?.show || gasNotification?.show}
            type={notification?.type || gasNotification?.type}
            message={notification?.message || gasNotification?.message}
            onClose={() =>
              gasNotification?.show
                ? updateGasNotification({ show: false, message: "", type: "" })
                : setNotification((prev) => ({ ...prev, show: false }))
            }
          />
        )}
      </div>
      <CaseDialog
        show={showCaseDialog}
        mode={caseModalMode}
        caseDetails={
          projectAndAffiliations?.length &&
          projectAndAffiliations[activeActionItem]
        }
        close={handleCaseDialogClose}
        showDesignType={true}
        designButtonOptions={
          designTypeButtonOptions?.map((option: any) => ({
            ...option,
            disabled: caseModalMode === "create" ? false : projectAndAffiliations?.[activeActionItem]?.liftType !== option?.id,
          }))}
      />
      <ConfirmationDialog
        confirmMsg='Are you sure you wish to remove this case from your list?'
        close={onConfirmationClose}
        show={showConfirmationDialog}
      />
      <Drawer
        isOpen={showMessageDrawer?.chat}
        onClose={() => {
          setShowMessageDrawer({ ...showMessageDrawer, chat: false });
          setSelectedId(null);
        }}
        showButton={false}
        title={LABELS?.comments}
        width="w-[600px]"
        bgColor="bg-darkcolor-800"
      >
        <Chat
          comments={latestComments}
          setComments={setComments}
          isEditing={isEditing}
          setIsEditing={setIsEditing}
          selectedId={selectedId}
          setSelectedId={setSelectedId}
          handlePostComment={handlePostComment}
          handleEditComment={handleEditComment}
          handleDeleteComment={handleDeleteComment}
          showTextarea={projectAndAffiliations?.find((x: any) => x.status === ProjectStatus.acknowldged)
            || projectAndAffiliations?.find((x: any) => x.status === ProjectStatus.archived) ? false : true}
        />
      </Drawer>
      <Drawer
        isOpen={showMessageDrawer?.changelog}
        onClose={() => setShowMessageDrawer({ ...showMessageDrawer, changelog: false })}
        children={
          <div className="flex flex-col comments-container p-4">
            <Changelog />
          </div>
        }
        showButton={false}
        title={LABELS?.changeLog}
        width="w-[65%]"
        bgColor="bg-darkcolor-800"
      />
    </div>
  );
};

export default ProjectHeader;
